/* Kimble consented telemetry transport: acknowledged batches, IndexedDB outbox, stable IDs. */
(() => {
  if(window.blushTelemetry)return;
  const endpoint='https://journal.blushmallow.com/shop-events';
  const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true&&navigator.globalPrivacyControl!==true;
  let dbPromise,visitor='',timer,busy=false,failures=0,memory=new Map();
  const stats={pending:0,retries:0,rejected:0,expired:0,storage:'indexeddb',lastAcknowledged:null};
  function identity(){
    if(visitor)return visitor;
    try{const x=JSON.parse(localStorage.getItem('blush_visitor_v1')||'null');visitor=x?.id&&x.expires>Date.now()?x.id:crypto.randomUUID();localStorage.setItem('blush_visitor_v1',JSON.stringify({id:visitor,expires:Date.now()+30*86400000}));}
    catch{visitor=crypto.randomUUID();}
    return visitor;
  }
  function database(){
    if(!dbPromise)dbPromise=new Promise((resolve,reject)=>{const r=indexedDB.open('blush_telemetry_v1',2);r.onupgradeneeded=()=>{const store=r.result.objectStoreNames.contains('events')?r.transaction.objectStore('events'):r.result.createObjectStore('events',{keyPath:'id'});if(!store.indexNames.contains('queued'))store.createIndex('queued','queued');};r.onsuccess=()=>resolve(r.result);r.onerror=()=>reject(r.error);});
    return dbPromise;
  }
  async function put(payload){
    const item={id:payload.id,payload,queued:Date.now()};memory.set(payload.id,item);if(memory.size>500)memory.delete(memory.keys().next().value);
    try{const db=await database();await new Promise((resolve,reject)=>{const tx=db.transaction('events','readwrite'),s=tx.objectStore('events');s.put(item);const count=s.count();count.onsuccess=()=>{stats.pending=count.result;if(count.result>500){let excess=count.result-500;const cursor=s.index('queued').openCursor();cursor.onsuccess=()=>{const c=cursor.result;if(c&&excess-->0){c.delete();stats.expired++;c.continue();}};}};tx.oncomplete=resolve;tx.onerror=reject;});}
    catch{stats.storage='memory fallback';memory.set(payload.id,item);if(memory.size>500){memory.delete(memory.keys().next().value);stats.expired++;}stats.pending=memory.size;}
  }
  async function read(){
    try{const db=await database();return await new Promise((resolve,reject)=>{const r=db.transaction('events').objectStore('events').getAll();r.onsuccess=()=>resolve([...new Map([...r.result,...memory.values()].map(x=>[x.id,x])).values()]);r.onerror=reject;});}
    catch{return [...memory.values()];}
  }
  async function remove(ids){
    ids.forEach(id=>memory.delete(id));
    try{const db=await database();await new Promise((resolve,reject)=>{const tx=db.transaction('events','readwrite');ids.forEach(id=>tx.objectStore('events').delete(id));tx.oncomplete=resolve;tx.onerror=reject;});}catch{}
  }
  function schedule(ms=80){clearTimeout(timer);timer=setTimeout(flush,ms);}
  async function flush(){
    if(busy||!allowed())return;
    busy=true;
    try{
      const items=await read();const expired=items.filter(x=>Date.now()-x.queued>86400000);if(expired.length){stats.expired+=expired.length;await remove(expired.map(x=>x.id));}
      const pending=items.filter(x=>Date.now()-x.queued<=86400000);stats.pending=pending.length;
      if(!pending.length)return;
      const batch=pending.sort((a,b)=>a.queued-b.queued).slice(0,20);
      const response=await fetch(endpoint,{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'text/plain'},body:JSON.stringify({events:batch.map(x=>x.payload)}),keepalive:true,signal:AbortSignal.timeout(10000)});
      if(response.status===204){await remove(batch.map(x=>x.id));}
      else{
        if(!response.ok)throw Error('retry');
        const receipt=await response.json();if(!Array.isArray(receipt.accepted))throw Error('unacknowledged');
        const rejected=Array.isArray(receipt.rejected)?receipt.rejected:[];stats.rejected+=rejected.length;
        await remove([...receipt.accepted,...rejected]);
      }
      stats.lastAcknowledged=new Date().toISOString();failures=0;stats.pending=Math.max(0,pending.length-batch.length);if(stats.pending)schedule(100);
    }catch{failures++;stats.retries++;schedule(Math.min(60000,1000*2**Math.min(failures,6))+Math.random()*500);}
    finally{busy=false;const remaining=await read();stats.pending=remaining.length;if(remaining.length&&allowed())schedule(failures?Math.min(60000,1000*2**Math.min(failures,6))+Math.random()*500:100);}
  }
  async function send(payload){
    if(!allowed())return;
    payload.visitor_id=identity();let attribution={};try{attribution=JSON.parse(sessionStorage.getItem('blush_shop_session_v1')||'{}').utm||{};}catch{}payload.utm_term=payload.utm_term||new URL(location.href).searchParams.get('utm_term')||attribution.term||'';let meta={};try{meta=JSON.parse(payload.signals||'{}');}catch{}payload.signals=JSON.stringify({...meta,tracker_version:'2026-10-30-consent-ready-v1',layout_version:document.querySelector('.seat-gallery')?'stone-editorial-v1':'storefront-v1'});
    await put(payload);schedule(document.visibilityState==='hidden'?0:80);
  }

  function clickLabel(el){
    const named=[['.seat-buy','buy:add_to_bag'],['.header-bag','header:bag'],['.header-contact','header:contact'],['.seat-brand','header:home'],['.dialog-close','gallery:zoom_close'],['.dialog-prev','gallery:zoom_previous'],['.dialog-next','gallery:zoom_next']];
    for(const [selector,label] of named)if(el.closest?.(selector))return label;
    const figure=el.closest?.('.seat-gallery figure');
    if(figure)return 'gallery:'+([...figure.classList].find(x=>x.startsWith('photo-'))||figure.id).replace('photo-','')+':zoom_open';
    if(el.closest?.('.gallery-nav'))return 'gallery:select:'+((el.getAttribute('href')||'').replace('#seat-photo-',''));
    if(el.tagName==='SUMMARY')return 'details:'+el.textContent.trim().replace(/\s+/g,' ').slice(0,70);
    if(el.tagName==='A'){try{const u=new URL(el.href,location.href);return (el.closest('footer')?'footer:':'link:')+(u.protocol==='mailto:'?'email':u.pathname).slice(0,80);}catch{}}
    return (el.getAttribute?.('aria-label')||el.getAttribute?.('alt')||(el.matches?.('button')?el.textContent:'')||el.tagName||'page').trim().replace(/\s+/g,' ').slice(0,100);
  }
  document.addEventListener('click',e=>{const a=e.target.closest?.('a[href]');if(a&&!a.getAttribute('href').startsWith('#'))flushImmediate();},{passive:true});
  function flushImmediate(){
    if(!allowed()||!memory.size)return;
    const events=[...memory.values()].slice(-20).map(x=>x.payload);
    // Keep the durable copy until acknowledged; the collector deduplicates these same IDs.
    try{navigator.sendBeacon(endpoint,JSON.stringify({events}));}catch{}
  }
  
  // Read the already loaded consent API before requesting another version.
  // Clarity can load 0.1 first; a conflicting 0.2 request can fail silently.
  function onPrivacyReady(callback) {
    let done=false, attempts=0, timer;
    function ready() {
      if(done)return true;
      if(typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed!=='function')return false;
      done=true;clearTimeout(timer);callback();return true;
    }
    if(ready())return;
    if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>ready());
    function retry(){if(!ready()&&++attempts<60)timer=setTimeout(retry,250);}
    retry();
  }

  window.blushTelemetry={send,flush,flushImmediate,clickLabel,stats,onPrivacyReady};
  window.addEventListener('online',()=>schedule(0),{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')flushImmediate();schedule(0);},{passive:true});
  window.addEventListener('pagehide',()=>{flushImmediate();schedule(0);},{passive:true});
  document.addEventListener('visitorConsentCollected',async()=>{if(allowed())schedule(0);else{clearTimeout(timer);memory.clear();visitor='';try{localStorage.removeItem('blush_visitor_v1');const db=await database();db.transaction('events','readwrite').objectStore('events').clear();}catch{}}});
})();

// blushmallow-shop-tracker-v4.js
// Supreme edition: every browser signal, zero-blocking, batched idle delivery.
(() => {
  'use strict';
  const script = document.currentScript;
  const productId = script?.dataset.productId || '';
  const handle = script?.dataset.productHandle || '';
  const family = handle === 'blushmallow-cozyride-pet-car-seat' ? 'seat'
    : handle.startsWith('blushmallow-doorway-mat-') ? 'mat' : '';
  if (!family || !/^\d{8,16}$/.test(productId) || !window.crypto?.randomUUID || window.__blushProductTracker) return;window.__blushProductTracker=true;

  const endpoint = 'https://journal.blushmallow.com/shop-events';
  const KEY = 'blush_shop_session_v1';
  const u = new URL(location.href);
  const utm = {
    source: u.searchParams.get('utm_source') || '',
    medium: u.searchParams.get('utm_medium') || '',
    campaign: u.searchParams.get('utm_campaign') || '',
    content: u.searchParams.get('utm_content') || '',
    term: u.searchParams.get('utm_term') || ''
  };
  const referrer = (() => { try { return new URL(document.referrer).hostname; } catch { return ''; } })();

  let session;
  try {
    session = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!session?.id || Date.now() - session.last > 30 * 60 * 1000) session = { id: crypto.randomUUID(), last: Date.now() };
    if (Object.values(utm).some(Boolean)) session.utm = utm;
    sessionStorage.setItem(KEY, JSON.stringify(session));
  } catch { session = { id: crypto.randomUUID(), last: Date.now() }; }

  let enabled = false;
  let started = false;
  let lastHiddenAt = 0;
  let lastExitUrl = '';
  let clsAccum = 0;

  // ── Device signals (collected at startup, sent with page_view) ────
  const signals = (() => {
    const c = navigator.connection;
    const nav0 = performance.getEntriesByType('navigation')[0];
    const s = {
      sw: screen.width, sh: screen.height,
      dpr: +window.devicePixelRatio.toFixed(2),
      cd: screen.colorDepth,
      vw: window.innerWidth, vh: window.innerHeight,
      cpu: navigator.hardwareConcurrency || null,
      ram: navigator.deviceMemory || null,
      touch: navigator.maxTouchPoints,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      lang: navigator.language,
      langs: (navigator.languages || []).slice(0, 4).join(','),
      net_type: c ? c.effectiveType : null,
      net_dl: c ? c.downlink : null,
      net_rtt: c ? c.rtt : null,
      save_data: c ? !!c.saveData : false,
      nav_type: nav0 ? nav0.type : null,
      hist: history.length,
      platform: (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || null,
      standalone: !!navigator.standalone,
      dnt: navigator.doNotTrack === '1',
      orientation: (screen.orientation && screen.orientation.type) || null,
    };
    return JSON.stringify(s).slice(0, 1800);
  })();

  // ── Canvas + WebGL fingerprint (cross-session device identity) ────
  const deviceFp = ''; // Stable consented browser IDs are supplied by the outbox.

  // ── Batch queue ──────────────────────────────────────────────────
  const queue = [];
  let flushScheduled = false;

  function enqueue(event, target = '', details = {}) {
    if(!enabled)return;
    sendOne({ event, target, details, at: new Date().toISOString() });
    return;
    if (!flushScheduled) {
      flushScheduled = true;
      const flush = () => { flushScheduled = false; flushQueue(); };
      if (window.requestIdleCallback) requestIdleCallback(flush, { timeout: 80 });
      else setTimeout(flush, 80);
    }
  }

  function flushQueue() {
    const active = enabled ? queue.splice(0) : [];
    if (!active.length) return;
    session.last = Date.now();
    try { sessionStorage.setItem(KEY, JSON.stringify(session)); } catch {}
    for (const item of active) sendOne(item);
  }

  function sendOne({ event, target, details, at }) {
    const payload = {
      id: crypto.randomUUID(),
      session_id: session.id,
      product_id: productId,
      product_handle: handle,
      path: location.pathname,
      event, target, at,
      viewport: window.innerWidth,
      consent: true,
      automation_hint: navigator.webdriver === true,
      utm_source: (session.utm || utm).source,
      utm_medium: (session.utm || utm).medium,
      utm_campaign: (session.utm || utm).campaign,
      utm_content: (session.utm || utm).content,
      referrer_host: referrer,
      duration_ms: details.duration_ms ?? null,
      visible_ms: details.visible_ms ?? null,
      load_ms: details.load_ms ?? null,
      scroll_pct: details.scroll_pct ?? null,
      section_ms: details.section_ms ?? null,
      // v4 fields
      signals: details.signals ?? null,
      device_fp: details.device_fp ?? null,
      exit_url: details.exit_url ?? null,
      email_partial: details.email_partial ?? null,
      offer_variant: details.offer_variant ?? null,
    };
    window.blushTelemetry.send(payload);
  }

  function sendNow(event, target = '', details = {}) {
    if (!enabled) return;
    sendOne({ event, target, details, at: new Date().toISOString() });
  }

  window.blushShopTrack = (event, target, details) => enqueue(event, target, details);

  // ── Performance vitals ────────────────────────────────────────────
  // FCP — First Contentful Paint
  function wireVitals() {
    try {
      const fcpE = performance.getEntriesByName('first-contentful-paint');
      if (fcpE.length) enqueue('perf_fcp', '', { duration_ms: Math.round(fcpE[0].startTime) });
      else new PerformanceObserver(list => {
        const e = list.getEntries()[0]; if (e) enqueue('perf_fcp', '', { duration_ms: Math.round(e.startTime) });
      }).observe({ type: 'paint', buffered: true });
    } catch {}
    // LCP — Largest Contentful Paint
    try {
      new PerformanceObserver(list => {
        const lcp = list.getEntries().at(-1);
        if (lcp) enqueue('perf_lcp', lcp.element?.tagName?.toLowerCase() || '', { duration_ms: Math.round(lcp.startTime) });
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch {}
    // CLS accumulator (sent at page_hidden)
    try {
      new PerformanceObserver(list => {
        for (const e of list.getEntries()) { if (!e.hadRecentInput) clsAccum += e.value; }
      }).observe({ type: 'layout-shift', buffered: true });
    } catch {}
    // INP — slow interactions >200 ms
    try {
      new PerformanceObserver(list => {
        for (const e of list.getEntries()) if (e.duration > 200) enqueue('perf_inp', e.name || 'slow', { duration_ms: Math.round(e.duration) });
      }).observe({ type: 'event', buffered: true, durationThreshold: 200 });
    } catch {}
  }

  // ── Battery ───────────────────────────────────────────────────────
  function wireBattery() {
    if (!navigator.getBattery) return;
    navigator.getBattery().then(batt => {
      const lvl = () => Math.round(batt.level * 100);
      enqueue('battery_signal', batt.charging ? 'charging' : 'discharging', { duration_ms: lvl() });
      batt.addEventListener('levelchange', () => {
        const l = lvl();
        enqueue(l <= 20 ? 'battery_low' : 'battery_signal', batt.charging ? 'charging' : 'discharging', { duration_ms: l });
      });
      batt.addEventListener('chargingchange', () => {
        enqueue('battery_signal', batt.charging ? 'charging' : 'discharging', { duration_ms: lvl() });
      });
    }).catch(() => {});
  }

  // ── Network monitoring ────────────────────────────────────────────
  function wireNetwork() {
    const c = navigator.connection;
    if (!c) return;
    if (c.rtt > 400 || c.effectiveType === 'slow-2g' || c.effectiveType === '2g')
      enqueue('network_slow', c.effectiveType || '', { duration_ms: c.rtt || 0 });
    c.addEventListener('change', () => {
      enqueue('network_change', c.effectiveType || '', { duration_ms: c.rtt || 0 });
    });
  }

  // ── Orientation ───────────────────────────────────────────────────
  function wireOrientation() {
    if (screen.orientation) {
      screen.orientation.addEventListener('change', () => enqueue('orientation_change', screen.orientation.type));
    } else {
      window.addEventListener('orientationchange', () =>
        enqueue('orientation_change', window.orientation === 0 || window.orientation === 180 ? 'portrait' : 'landscape'));
    }
  }

  // ── Exit URL (outbound link tracking) ────────────────────────────
  function wireExitLinks() {
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      try {
        const url = new URL(a.href);
        if (url.hostname && url.hostname !== location.hostname) {
          lastExitUrl = url.href.slice(0, 200);
          enqueue('exit_link', (url.hostname + url.pathname).slice(0, 100));
        }
      } catch {}
    }, { capture: true, passive: true });
  }

  // ── Client Hints (async high-entropy) ────────────────────────────
  function wireClientHints() {
    if (!navigator.userAgentData) return;
    navigator.userAgentData.getHighEntropyValues([
      'architecture', 'bitness', 'model', 'platform', 'platformVersion', 'uaFullVersion'
    ]).then(h => {
      enqueue('client_hints', h.platform || '', { signals: JSON.stringify(h).slice(0, 400) });
    }).catch(() => {});
  }

  // ── Scroll tracking ──────────────────────────────────────────────
  const sentScroll = new Set();
  let lastScrollPct = 0;
  let scrollT0 = {}; // mark → timestamp first reached
  let scrollThrottle = false;

  function onScroll() {
    if (scrollThrottle) return;
    scrollThrottle = true;
    requestAnimationFrame(() => {
      scrollThrottle = false;
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const pct = Math.round(Math.min(100, (scrollY / h) * 100));
      lastScrollPct = pct;
      for (const mark of [10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 100]) {
        if (pct >= mark && !sentScroll.has(mark)) {
          sentScroll.add(mark);
          scrollT0[mark] = Date.now();
          enqueue('scroll_' + mark, '', { scroll_pct: pct });
        }
      }
    });
  }

  // ── Section visibility ────────────────────────────────────────────
  const sectionEnterTimes = new Map();
  const sectionReadSent = new Set();

  const sectionObserver = new IntersectionObserver(entries => {
    if(!enabled||document.visibilityState==='hidden')return;
    for (const entry of entries) {
      const id = entry.target.dataset.trackSection;
      if (!id) continue;
      if (entry.isIntersecting&&entry.intersectionRatio>=0.3) {
        if(sectionEnterTimes.has(id))continue;
        const startedReading=Date.now();sectionEnterTimes.set(id,startedReading);
        enqueue('section_enter', id, { scroll_pct: lastScrollPct });
        setTimeout(() => {
          if (document.visibilityState==='visible'&&sectionEnterTimes.get(id)===startedReading && !sectionReadSent.has(id)) {
            sectionReadSent.add(id);
            enqueue('section_read', id, { section_ms: Date.now() - (sectionEnterTimes.get(id) || Date.now()) });
          }
        }, 5000);
      } else {
        const entered = sectionEnterTimes.get(id);
        if (entered) {
          const ms = Date.now() - entered;
          sectionEnterTimes.delete(id);
          enqueue('section_exit', id, { section_ms: ms, scroll_pct: lastScrollPct });
        }
      }
    }
  }, { threshold: 0.3 });

  function observeSections() {
    const sectionMap = {
      '.seat-product-info': 'product_information', '.seat-gallery': 'product_photos', '.product-details': 'product_details', '.seat-footer': 'footer', '.seat-hero': 'hero', '.seat-band': 'feature_band', '.seat-lifestyle': 'lifestyle',
      '#setup': 'setup_steps', '#size': 'specs_faq', '.seat-reviews': 'reviews',
      '.seat-guarantee': 'guarantee', '.seat-brand-story': 'brand_story', '#seat-offer': 'offer_card',
    };
    for (const [sel, id] of Object.entries(sectionMap)) {
      const el = document.querySelector(sel);
      if (!el) continue;
      el.dataset.trackSection = id;
      sectionObserver.observe(el);
    }
  }

  // ── Gallery tracking ─────────────────────────────────────────────
  let currentPhoto = 1, photoEnterTime = Date.now();

  function onGalleryClick(el) {
    const href = el.getAttribute('href') || '';
    const match = href.match(/#seat-photo-(\d+)/);
    if (!match) return;
    enqueue('gallery_photo', `photo_${currentPhoto}_exit`, { section_ms: Date.now() - photoEnterTime });
    currentPhoto = Number(match[1]);
    photoEnterTime = Date.now();
    enqueue('gallery_photo', `photo_${currentPhoto}_enter`, {});
  }

  // ── FAQ tracking ─────────────────────────────────────────────────
  function onFaqToggle(summary) {
    const details = summary.closest('details');
    const text = (summary.textContent || '').trim().slice(0, 80);
    setTimeout(() => enqueue(details?.hasAttribute('open') ? 'faq_expand' : 'faq_collapse', text), 0);
  }

  // ── CTA + price hover ─────────────────────────────────────────────
  let ctaHoverStart = 0, priceHoverStart = 0;

  function wireCta() {
    const btn = document.querySelector('.seat-buy');
    if (btn) {
      btn.addEventListener('mouseenter', () => { ctaHoverStart = Date.now(); }, { passive: true });
      btn.addEventListener('mouseleave', () => {
        if (!ctaHoverStart) return;
        enqueue('cta_hover', 'buy_btn', { duration_ms: Date.now() - ctaHoverStart });
        ctaHoverStart = 0;
      }, { passive: true });
      btn.addEventListener('touchstart', () => enqueue('cta_touch', 'buy_btn'), { passive: true });
    }
    // Price block hover — separates price curiosity from buy intent
    const price = document.querySelector('.seat-price');
    if (price) {
      price.addEventListener('mouseenter', () => { priceHoverStart = Date.now(); }, { passive: true });
      price.addEventListener('mouseleave', () => {
        if (!priceHoverStart) return;
        enqueue('price_hover', 'price_block', { duration_ms: Date.now() - priceHoverStart });
        priceHoverStart = 0;
      }, { passive: true });
    }
  }

  // ── Idle detection ────────────────────────────────────────────────
  const IDLE_MS = 30_000;
  let idleTimer = null, idleStart = 0, isIdle = false;

  function resetIdle() {
    if (isIdle) { isIdle = false; enqueue('idle_end', '', { duration_ms: Date.now() - idleStart }); }
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => { isIdle = true; idleStart = Date.now(); enqueue('idle_start', ''); }, IDLE_MS);
  }

  // ── Copy detection ────────────────────────────────────────────────
  function onCopy(e) {
    if(e.target.closest?.('input,textarea,[contenteditable="true"]'))return;
    if(window.getSelection?.()?.toString?.())enqueue('copy_text','product_information');
  }

  // ── Review form ───────────────────────────────────────────────────
  let reviewStarted = false;
  function onReviewFocus() { if (reviewStarted) return; reviewStarted = true; enqueue('review_start', ''); }

  // ── Video tracking ────────────────────────────────────────────────
  function wireVideos() {
    document.querySelectorAll('video').forEach((v, i) => {
      const id = v.id || `video_${i}`;
      v.addEventListener('play', () => enqueue('video_play', id), { passive: true });
      v.addEventListener('pause', () => enqueue('video_pause', id, { duration_ms: Math.round(v.currentTime * 1000) }), { passive: true });
      v.addEventListener('ended', () => enqueue('video_end', id, { duration_ms: Math.round(v.duration * 1000) }), { passive: true });
    });
  }

  // ── Click dispatcher ─────────────────────────────────────────────
  function onClick(event) {
    const el = event.target.closest?.('a,button,summary,select,input');
    if (!el) return;
    if (el.matches('.seat-buy')) { enqueue('cta_click', 'add_to_cart'); return; }
    if (el.closest('.seat-thumbs,.gallery-nav')) { enqueue('gallery_click',window.blushTelemetry.clickLabel(el)); return; }
    if (el.tagName === 'SUMMARY') return;
    if (el.matches('select,input')) { enqueue('option_click', el.getAttribute('name') || el.type || 'option'); return; }
    if(el.matches('.photo-zoom,.dialog-next,.dialog-prev,.dialog-close'))return;
    if (el.matches('a,button')) {
      const href = el.getAttribute('href') || '';
      const label = (el.getAttribute('aria-label') || el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
      enqueue('link_click',window.blushTelemetry.clickLabel(el));
    }
  }


  const photoViews=new Map();let photoObserver;
  const photoName=el=>([...el.classList].find(x=>x.startsWith('photo-'))||el.id).replace('photo-','');
  function endPhotoViews(){for(const [el,at] of photoViews)enqueue('gallery_photo','photo_'+photoName(el)+'_exit',{section_ms:Date.now()-at});photoViews.clear();}
  function wireProductDetails(){
    document.querySelectorAll('.product-details details').forEach(el=>{let wasOpen=el.open;el.addEventListener('toggle',()=>{if(el.open===wasOpen)return;wasOpen=el.open;enqueue(el.open?'faq_expand':'faq_collapse','details:'+(el.id||el.querySelector('summary').textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'_')));});});
    document.addEventListener('blush:gallery',e=>{const d=e.detail||{};enqueue('gallery_click','gallery:'+d.photo+':'+d.action);});
    if(!window.IntersectionObserver)return;
    photoObserver=new IntersectionObserver(entries=>{if(!enabled||document.visibilityState==='hidden')return;for(const e of entries){if(e.isIntersecting&&e.intersectionRatio>=.5){if(!photoViews.has(e.target)){photoViews.set(e.target,Date.now());enqueue('gallery_photo','photo_'+photoName(e.target)+'_enter');}}else if(photoViews.has(e.target)){enqueue('gallery_photo','photo_'+photoName(e.target)+'_exit',{section_ms:Date.now()-photoViews.get(e.target)});photoViews.delete(e.target);}}},{threshold:[0,.5]});
    const observe=()=>document.querySelectorAll('.seat-gallery figure').forEach(el=>{photoObserver.unobserve(el);photoObserver.observe(el);});observe();
    document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')endPhotoViews();else if(enabled)observe();});
  }

  // ── Boot ─────────────────────────────────────────────────────────
  function start() {
    if (started) return;
    started = true;

    wireProductDetails();
    wireVitals();
    wireBattery();
    wireNetwork();
    wireOrientation();
    wireExitLinks();
    wireClientHints();

    const nav = performance.getEntriesByType('navigation')[0];
    const isReturn = nav?.type === 'back_forward';

    // page_view — all device signals attached
    sendNow('page_view', '', {
      load_ms: Math.round(nav?.domContentLoadedEventEnd || performance.now()),
      signals,
      device_fp: deviceFp,
    });

    // return visit — back button navigation
    if (isReturn) enqueue('return_visit', 'back_forward');

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', onClick, { capture: true, passive: true });
    document.addEventListener('click', e => {
      if(!enabled||!e.isTrusted)return;
      const el=e.target.closest?.('a,button,img,summary,label')||e.target;
      if(el.closest?.('input,textarea,[contenteditable="true"]'))return;
      const w=Math.max(document.documentElement.scrollWidth,innerWidth),h=Math.max(document.documentElement.scrollHeight,innerHeight);
      const label=window.blushTelemetry.clickLabel(el);
      enqueue('page_click',label,{signals:JSON.stringify({x_pct:Math.max(0,Math.min(100,e.pageX/w*100)),y_pct:Math.max(0,Math.min(100,e.pageY/h*100)),page_width:w,page_height:h,viewport_width:innerWidth,viewport_height:innerHeight})});
    },{passive:true,capture:true});
    let emailTyped=false;
    document.addEventListener('input',e=>{if(!emailTyped&&e.target.matches?.('input[type="email"]')&&e.target.value){emailTyped=true;enqueue('offer_email_typed','email field');}},{passive:true});

    const activityEvents = ['click', 'scroll', 'touchstart', 'keydown', 'mousemove'];
    for (const ev of activityEvents) document.addEventListener(ev, resetIdle, { passive: true });
    resetIdle();
    document.addEventListener('copy', onCopy, { passive: true });

    const hidden = reason => {
      if(!enabled)return;
      if (Date.now() - lastHiddenAt < 1200) return;
      lastHiddenAt = Date.now();
      for (const [id, enterTime] of sectionEnterTimes.entries()) {
        queue.push({ event: 'section_exit', target: id, details: { section_ms: Date.now() - enterTime, scroll_pct: lastScrollPct }, at: new Date().toISOString() });
      }
      sectionEnterTimes.clear();
      sendNow('page_hidden', reason, {
        duration_ms: Math.round(performance.now()),
        scroll_pct: lastScrollPct,
        exit_url: lastExitUrl,
      });
      if (clsAccum > 0.01) sendNow('perf_cls', '', { duration_ms: Math.round(clsAccum * 1000) });
      flushQueue();
      endPhotoViews();window.blushTelemetry.flushImmediate();
    };

    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') hidden('tab_hidden');else if(enabled){document.querySelectorAll('[data-track-section]').forEach(el=>{sectionObserver.unobserve(el);sectionObserver.observe(el);});} }, { passive: true });
    window.addEventListener('pagehide', () => hidden('page_exit'), { passive: true });

    if (window.IntersectionObserver) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeSections);
      else observeSections();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { wireCta(); wireVideos(); });
    else { wireCta(); wireVideos(); }

    document.querySelectorAll('#seat-review-form input, #seat-review-form textarea').forEach(el => {
      el.addEventListener('focus', onReviewFocus, { once: true, passive: true });
    });
  }

  function consent() {
    enabled = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && navigator.globalPrivacyControl !== true;
    if (enabled) start();else{queue.length=0;sectionEnterTimes.clear();photoViews.clear();clearTimeout(idleTimer);}
  }

  document.addEventListener('visitorConsentCollected', consent);
  window.blushTelemetry.onPrivacyReady(consent);
})();

/* Store-wide page coverage. Product/cart/funnel views retain their specialized collectors. */
(() => {
 'use strict';
 if(!crypto?.randomUUID||window.__kimbleSiteTracker)return;window.__kimbleSiteTracker=true;
 const path=location.pathname;
 if(/^\/(checkouts?|account|admin)(\/|$)/.test(path))return;
 const specialized=/^\/products\/blushmallow-(cozyride-pet-car-seat|doorway-mat-)/.test(path)||path==='/pages/for-the-dog-who-goes-everywhere';
 const key='blush_shop_session_v1';let started=false,enabled=false,session;
 const query=new URLSearchParams(location.search),utm={source:query.get('utm_source')||'',medium:query.get('utm_medium')||'',campaign:query.get('utm_campaign')||'',content:query.get('utm_content')||'',term:query.get('utm_term')||''};
 function getSession(){try{session=JSON.parse(sessionStorage.getItem(key)||'null');}catch{}if(!session?.id||Date.now()-session.last>1800000)session={id:crypto.randomUUID(),last:Date.now()};if(Object.values(utm).some(Boolean))session.utm=utm;return session;}
 function send(event,target='',details={}){if(!enabled)return;getSession();session.last=Date.now();try{sessionStorage.setItem(key,JSON.stringify(session));}catch{}const u=session.utm||utm;window.blushTelemetry.send({id:crypto.randomUUID(),session_id:session.id,product_id:'0',product_handle:'blushmallow-storefront',path,event,target,at:new Date().toISOString(),viewport:innerWidth,consent:true,automation_hint:navigator.webdriver===true,utm_source:u.source,utm_medium:u.medium,utm_campaign:u.campaign,utm_content:u.content,utm_term:u.term,referrer_host:(()=>{try{return new URL(document.referrer).hostname;}catch{return '';}})(),...details});}
 // Observe successful Shopify AJAX cart responses without changing requests or waiting on analytics.
 const originalFetch=window.fetch;
 window.fetch=function(...args){const response=originalFetch.apply(this,args);try{const url=new URL(args[0] instanceof Request?args[0].url:String(args[0]),location.href);if(url.origin===location.origin&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add(?:\.js)?$/.test(url.pathname)){response.then(r=>{if(!r.ok||!enabled)return;r.clone().json().then(cart=>{const items=cart.items||[cart];if(items.some(i=>i.product_id&&i.quantity>0))send('cart_add_confirmed','Shopify confirmed cart addition',{signals:JSON.stringify({items:items.map(i=>({product_id:i.product_id,variant_id:i.variant_id,quantity:i.quantity})).slice(0,10)})});}).catch(()=>{});}).catch(()=>{});}}catch{}return response;};
 function start(){if(started)return;started=true;if(!/^\/products\/blushmallow-/.test(path)){  document.addEventListener('click',e=>{if(!e.isTrusted)return;const el=e.target.closest?.('a,button,summary,img');if(!el||el.closest('input,textarea,[contenteditable="true"]'))return;const w=Math.max(innerWidth,document.documentElement.scrollWidth),h=Math.max(innerHeight,document.documentElement.scrollHeight);send('page_click',window.blushTelemetry.clickLabel(el),{signals:JSON.stringify({x_pct:Math.min(100,Math.max(0,e.pageX/w*100)),y_pct:Math.min(100,Math.max(0,e.pageY/h*100)),page_width:w,page_height:h,viewport_width:innerWidth,viewport_height:innerHeight})});if(el.tagName==='A'){let target='';try{const u=new URL(el.href);target=u.origin===location.origin?u.pathname:u.hostname+u.pathname;}catch{}send('link_click',target.slice(0,100));}},{capture:true,passive:true});}if(specialized)return;
  send('page_view',document.title.slice(0,100),{load_ms:Math.round(performance.now()),signals:JSON.stringify({sw:screen.width,sh:screen.height,vw:innerWidth,vh:innerHeight,lang:navigator.language,tz:Intl.DateTimeFormat().resolvedOptions().timeZone})});
  const marks=new Set();let scrollTimer;
  window.addEventListener('scroll',()=>{if(scrollTimer)return;scrollTimer=setTimeout(()=>{scrollTimer=null;const max=Math.max(1,document.documentElement.scrollHeight-innerHeight),pct=Math.min(100,Math.round(scrollY/max*100));for(const n of [10,25,50,75,90,100])if(pct>=n&&!marks.has(n)){marks.add(n);send('scroll_'+n,'',{scroll_pct:pct});}},150);},{passive:true});

  const entered=new Map();if(window.IntersectionObserver){const observer=new IntersectionObserver(entries=>{for(const e of entries){const id=e.target.dataset.kimbleSection;if(e.isIntersecting){if(!entered.has(id)){entered.set(id,performance.now());send('section_enter',id);}}else if(entered.has(id)){send('section_exit',id,{section_ms:Math.round(performance.now()-entered.get(id))});entered.delete(id);}}},{threshold:.3});document.querySelectorAll('main section,main article').forEach((el,i)=>{el.dataset.kimbleSection=(el.querySelector('h1,h2,h3')?.textContent?.trim()||'Section '+(i+1)).slice(0,80);observer.observe(el);});}
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden'){send('page_hidden','tab hidden',{duration_ms:Math.round(performance.now())});for(const [id,at] of entered)send('section_exit',id,{section_ms:Math.round(performance.now()-at)});entered.clear();}},{passive:true});
 }
 function consent(){enabled=window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true&&navigator.globalPrivacyControl!==true;if(enabled)start();}
 document.addEventListener('visitorConsentCollected',consent);window.blushTelemetry.onPrivacyReady(consent);
})();
